export const ADMIN = 'ADMIN'
export const RESEARCHER = 'RESEARCHER'
export const PARTICIPANT = 'PARTICIPANT'

export type Type = {
    ADMIN: string,
    RESEARCHER: string,
    PARTICIPANT: string
}